const SparkleIcon = () => {
  return (
    // <svg width="16" height="16" viewBox="0 0 48 48" aria-hidden="true">
    //   <path
    //     d="M24 3 C25 14 26 17 45 24 C26 31 25 34 24 45 C23 34 22 31 3 24 C22 17 23 14 24 3 Z"
    //     fill="var(--brand-color)"></path>
    // </svg>
    <svg width="20" height="20" viewBox="0 0 48 48" aria-hidden="true">
      <path
        d="M24 3 C25 14 26 17 45 24 C26 31 25 34 24 45 C23 34 22 31 3 24 C22 17 23 14 24 3 Z"
        fill="var(--brand-color)"></path>
      <path
        d="M39 5 C39.5 10 40 11.5 46 13 C40 14.5 39.5 16 39 21 C38.5 16 38 14.5 32 13 C38 11.5 38.5 10 39 5 Z"
        fill="var(--brand-color)"
        opacity=".7"></path>
    </svg>
  );
};

export default SparkleIcon;
